import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.admin.detail');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-institute-admin-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.admin.detail/view.scss */
/* src/app/portal.institute.admin.detail/view.scss: no such file or directory */`],
})
export class PortalInstituteAdminDetailComponent implements OnInit, DoCheck {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title,@Inject( Router)  private router: Router) { }

    @Input() insID: any;
    @Input() mode: any;
    @Input() item: any;

    public async ngDoCheck() {
        if (this.router.url !== this.lastUrl) {
            this.lastUrl = this.router.url;
            this.insID = WizRoute.segment.id;
            this.mode = WizRoute.segment.mode;
            this.item = WizRoute.segment.item;
            // this.load();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        // this.title.setTitle("기관정보 - MY KREONET");
    }
}

export default PortalInstituteAdminDetailComponent;